import React from "react";
import {
    CheckCardIcon,
    CheckOutlineIcon,
    CommentOutlineIcon,
    DeniedOutlineIcon, IconCircleCross, IconDraft,
    IconLine, IconPendingToReviewInformationCard, IconPendingToUploadInformationCard, WarningChip
} from "../../../../components/buttons/IconButtons";
import {FILE_MODEL} from "../../../Dashboard/Visitor/Visitor/Model/Model";
import {STATUS_MODEL} from "../../../../enums/statusEnum";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05/12/2025
 */

export const TABS_COMPANY_DOCUMENTATION = {
    REQUEST: {
        INDEX: 0,
        TRANS: "request",
    },
    HISTORY: {
        INDEX: 1,
        TRANS: "history",
    },
}



export function TAB_PERMISSION_COMPANY_DOCUMENTATION(step) {
    return {
        SAVE: {
            [TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX]: step === TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX,
            [TABS_COMPANY_DOCUMENTATION.HISTORY.INDEX]: false,
        },
        SUBMIT: {
            [TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX]: step === TABS_COMPANY_DOCUMENTATION.REQUEST.INDEX,
            [TABS_COMPANY_DOCUMENTATION.HISTORY.INDEX]: false,
        }
    };
}

export const REQUEST_APPROVAL_MODEL = {
    id: null,
    profile: null,
    serviceType: null,
    userType: null,
    levels: [],

    set: function (data) {
        const model = { ...REQUEST_APPROVAL_MODEL };
        model.id = data.id || null;
        model.profile = data.profile || null;
        model.serviceType = data.serviceType || null;
        model.userType = data.userType || null;

        model.levels = Array.isArray(data.levels)
            ? data.levels.map(item => LEVEL_MODEL.set(item))
            : [];
        return model;
    },

    isValid: function () {
        return this.level.length > 0;
    },

    toRegister: function () {
        return {
            id: this.id,
            profile: this.profile,
            serviceType: this.serviceType,
            userType: this.userType,
            levels: this.levels.map(level => level.toRegister())
        };
    }
};


export const LEVEL_MODEL = {
    id: null,
    name: '',
    levelNumber: null,
    description: '',
    document: '',
    department: null,
    type: '',
    pathFile: null,

    fileUploadDto: null,
    fileKey: null,

    userLevel : null,

    set: function (data) {
        const model = {...LEVEL_MODEL};

        model.id = data.id || null;
        model.name = data.name || '';
        model.levelNumber = data.levelNumber || null;
        model.description = data.description || '';
        model.department = data.department || null;
        model.type = data.type || '';
        model.pathFile = data.pathFile || null;

        model.fileKey = data.fileKey || null;
        model.file = data.file || null;
        model.fileName = data.fileName || null;
        model.fileUploadDto = data.fileUploadDto ? FILE_MODEL.set(data) : null;
        model.userLevel = data.userLevel ? USER_LEVEL_MODEL.set(data.userLevel) : null;

        return model;
    },

    toRegister: function () {
        return {
            id: this.id,
            name: this.name?.trim(),
            levelNumber: this.levelNumber,
            description: this.description?.trim() || null,
            department: this.department,
            type: this.type,
            pathFile: this.pathFile,
            fileKey: this.fileKey,

            userLevel: this.userLevel ? this.userLevel.toRegister() : null
        };
    }
};

export const USER_LEVEL_MODEL = {
    id: null,
    document: null,
    fileUploadDto: null,
    approverFullName: null,
    statusId: null,
    reason: '',
    decisionDate: null,
    modified: false,

    set: function (data) {
        if (!data || typeof data !== 'object') {
            return null;
        }
        const model = { ...USER_LEVEL_MODEL  };

        model.id = data.id || null;
        model.document = data.document || '';
        model.approverFullName = data.approverFullName || '';
        model.statusId = data.statusId || null;
        model.reason = data.reason || '';
        model.decisionDate = data.decisionDate || null;
        model.fileUploadDto = data.fileUploadDto ? FILE_MODEL.set(data) : null;
        return model;
    },

    toRegister: function () {
        return {
            document: this.document,
            approverFullName: this.approverFullName,
            statusId: this.statusId,
            reason: this.reason?.trim(),
            decisionDate: this.decisionDate,
        };
    }
};


export const REQUEST_DOCUMENTATION_ICON_MODEL= {
    [STATUS_MODEL.PRE_REGISTERED] : IconLine,
    [STATUS_MODEL.APPROVED] : CheckOutlineIcon,
    [STATUS_MODEL.CHANGES_REQUESTED] : CommentOutlineIcon,
    [STATUS_MODEL.DENIED] : DeniedOutlineIcon,
    [STATUS_MODEL.PENDING_REVIEW] : IconPendingToReviewInformationCard,
    [STATUS_MODEL.DRAFT] : IconDraft,
    [STATUS_MODEL.PENDING] : IconPendingToUploadInformationCard
}

export const REQUEST_DOCUMENTATION_BADGE_MODEL= {
    [STATUS_MODEL.APPROVED] : CheckCardIcon,
    [STATUS_MODEL.CHANGES_REQUESTED] : WarningChip,
    [STATUS_MODEL.DENIED]  : IconCircleCross,
    [STATUS_MODEL.DRAFT]  : IconDraft,
}

export const REQUEST_DOCUMENTATION_FONT_COLOR_MODEL = {
    [STATUS_MODEL.APPROVED]: "font-color-success-600",
    [STATUS_MODEL.CHANGES_REQUESTED]: "font-color-warning-600",
    [STATUS_MODEL.DENIED]: "font-color-error-600",
    [STATUS_MODEL.PENDING_REVIEW]: "font-color-shades-600",
    [STATUS_MODEL.IN_PROGRESS]: "font-color-success-600",
    [STATUS_MODEL.DRAFT]: "font-color-secondary-600",
}
